<div class="menu" [class.open]="isMenuOpen">
    <!-- Logo + burger share one fixed-height row, so expanding the mobile
         panel below them cannot shift the logo. -->
    <div class="bar-row">
        <img src="assets/images/homepage/fyes-logo-white.png" alt="" (click)="goTo('')" class="cursor-pointer">

        <!-- Right: Burger Icon (mobile) -->
        <div class="burger" [class.open]="isMenuOpen" (click)="toggleMenu()">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>

    <div class="menu-items gap-3" [class.open]="isMenuOpen">
        <a (click)="scrollToSection('cards-section')">{{ 'nav_what_we_do' | translate }}</a>
        <a (click)="scrollToSection('tabs-section')">{{ 'nav_solutions' | translate }}</a>
        <a (click)="scrollToSection('projects-section')">{{ 'nav_case_studies' | translate }}</a>
        <a (click)="goTo('about-us')">{{ 'nav_about_us' | translate }}</a>
        <a (click)="goTo('contact')">{{ 'nav_contact' | translate }}</a>
    </div>

    <div class="right-area">
        @if (session.isLoggedIn()) {
            <div class="account-menu" [class.open]="isAccountOpen">
                <button class="account-btn" (click)="toggleAccount()">{{ 'account_menu' | translate }} <fa-icon [icon]="faChevronDown" class="caret"></fa-icon></button>
                <!-- Two entries for every role. The sections themselves now live
                     in the single tab bar (app-admin-nav), which gates each tab
                     by the same rule as its route guard. -->
                <div class="account-dropdown">
                    <a (click)="goTo('account')">{{ 'account_details' | translate }}</a>
                    <a (click)="logout()">{{ 'account_logout' | translate }}</a>
                </div>
            </div>
        } @else {
            <div class="login-area">
                <span class="login-link" (click)="openAuth('login')">{{ 'auth_login' | translate }}</span>
                <button class="white-btn" (click)="openAuth('signup')">{{ 'auth_sign_up' | translate }}</button>
            </div>
        }
        <!-- Same open/close model as the account menu above: hover on desktop,
             click-to-expand inline on mobile. -->
        <div class="lang-menu" [class.open]="isLangOpen">
            <button class="lang-btn" (click)="toggleLang()">{{ selectedLangLabel }} <fa-icon [icon]="faChevronDown" class="caret"></fa-icon></button>
            <div class="lang-dropdown">
                @for (lang of languages; track lang.code) {
                    <a [class.active]="lang.code === selectedLang" (click)="changeLanguage(lang.code)">{{ lang.label }}</a>
                }
            </div>
        </div>
    </div>
</div>